/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { UserListInvitationsQueryParams, UserListInvitationsResponse } from '../types/UserListInvitations'

/**
 * GET /invitations
 * @see backend/nexus/modules/Organisation/Http/Controllers/UserController.php UserController::listInvitations
 */
export async function userListInvitations(
	params?: UserListInvitationsQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<UserListInvitationsResponse>> {
	return axiosInstance.get('/invitations', { params, ...config })
}
